/* eslint-disable */
//递归获取 views 文件夹下的所有.vue文件
const files = require.context('@/utils/languages/en', true, /\.json$/)
let en = {};
files.keys().forEach(key => {
	const data = require('' + key);
	en = { ...en, ...data }
})
export default en;
